module.exports = __webpack_public_path__ + "static/media/hoop_other.557abbd7.obj";


//////////////////
// WEBPACK FOOTER
// ./src/model/hoop_other.obj
// module id = 19
// module chunks = 0